<label class="input" [class.hasPrice]="currency">
  <p *ngIf="title" class="title">
    {{title}}
  </p>
  <div *ngIf="icon" [class.hasIcon]="icon" class="input-icon-container">
    <input class="field"
           autocomplete="off"
           [placeholder]="placeholder"
           [type]="type"
           [min]="type === 'number' ? min : ''"
           [max]="type === 'number' ? max : ''"
           [ngModel]="value"
           [disabled]="disabled"
           (blur)="onTouch($event)"
           [(ngModel)]="value"
           (ngModelChange)="onModelChange($event)"
    />
    <app-icon [name]="icon" class="input-icon" size="md"></app-icon>
  </div>
  <ng-container *ngIf="!icon">
    <input class="field"
           autocomplete="off"
           [placeholder]="placeholder"
           [type]="type"
           [min]="type === 'number' ? min : ''"
           [max]="type === 'number' ? max : ''"
           [ngModel]="value"
           [disabled]="disabled"
           (blur)="onTouch($event)"
           [(ngModel)]="value"
           (ngModelChange)="onModelChange($event)"
    />
  </ng-container>
  <span *ngIf="value && clearable" class="clear" (click)="onClear()">
    ×
  </span>
</label>
